import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("admin@hiraya.studio");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav(loc.state?.from || "/admin", { replace: true }); }, [user, nav, loc]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); } catch (_e) {} finally { setLoading(false); }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#1A1918] text-[#EAE6DF] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="font-serif text-5xl tracking-tight text-[#F9F8F6] text-center">Hiraya</div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#8A837A] text-center mt-2 mb-10">Admin sign-in</div>
        <form onSubmit={onSubmit} className="bg-[#242220] p-8 rounded-sm border border-[#3A3734] space-y-5">
          <label className="block">
            <span className="block text-[10px] uppercase tracking-[0.28em] text-[#8A837A] mb-2">Email</span>
            <input required type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#1A1918] border border-[#3A3734] px-4 py-3 rounded-sm text-[#F9F8F6] outline-none focus:border-[#A85C42]" />
          </label>
          <label className="block">
            <span className="block text-[10px] uppercase tracking-[0.28em] text-[#8A837A] mb-2">Password</span>
            <input required type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#1A1918] border border-[#3A3734] px-4 py-3 rounded-sm text-[#F9F8F6] outline-none focus:border-[#A85C42]" />
          </label>
          {error && <div data-testid="login-error" className="text-sm text-[#E28C6A]">{error}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full py-3 bg-[#A85C42] text-white text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#C57457] transition-colors disabled:opacity-60">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
